import { useState, useContext, useEffect } from "react";
import blackDeleteIcon from "../../assets/black-delete-icon.svg";
import whiteRightIcon from "../../assets/white-right-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import { CaseStageContext } from "../../dashboard/cases/contexts/CaseContexts";

const DiagnosisForm = ({ caseStage }) => {
  // const [data, setData] = useState([]);
  const { caseDetails } = useContext(CaseStageContext);
  const primary = caseDetails?.primaryDiagnosisDetails;
  const secondary = caseDetails?.secondaryDiagnosisDetails;
  const data = [];
  if (primary) {
    data.push({ ...primary, type: "Primary" });
  }
  if (secondary) {
    data.push({ ...secondary, type: "Secondary" });
  }

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="pt-[30px]">
        {/* Table Header */}
        <div className="grid grid-cols-[0.5fr_1fr_4fr_1fr] items-center">
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Diagnosis Code
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Diagnosis Description
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Diagnosis Type
          </div>

          {/* <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Action
          </div> */}
        </div>

        {/* Table Body */}
        <div className="mt-[30px] flex flex-col gap-y-[21px]">
          {" "}
          {data?.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-[0.5fr_1fr_4fr_1fr] items-start"
            >
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {index + 1}.
              </div>

              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.code || "--"}
              </div>

              <div className="pr-[40px] font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.title || "--"}
              </div>

              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.type || "--"}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Save Section */}
      <div className="flex justify-end items-center gap-[10px] mt-[40px]">
        {/* Saved Button */}
        {/* <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
          SAVED
          <img src={whiteRightIcon} alt="white icon" />
        </button> */}

        {/* Edit Button */}
        {/* <button className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent">
          <img src={editIcon} alt="edit icon" />
        </button> */}
      </div>
    </div>
  );
};

export default DiagnosisForm;
